// extracted by mini-css-extract-plugin
export default {"DroppableTableCell":"DroppableTableCell_DroppableTableCell__fRSrr","isSource":"DroppableTableCell_isSource__hO1hX","Dragging":"DroppableTableCell_Dragging__uO1Lu"};